import React from "react";
//outsource
import { Row, Col, DatePicker } from "antd";

//components

const DialogDate = ({ date, setDate, disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (date) => {
    console.log({ date });
    setDate(date);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <DatePicker
      format="DD/MM/YYYY"
      placeholder="Choose Date"
      onChange={handleChange}
      //   onBlur={handleBlur}
      picker="date"
      disabled={disabled}
      value={date}
      allowClear={false}
    />
  );
};

export default DialogDate;
